module.exports = __webpack_public_path__ + "static/img/pending2.ecea926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/pending2.png
// module id = LTlc
// module chunks = 0